import { useTheme } from "@mui/material";
import Highcharts from "highcharts";
import { merge } from "lodash";
import { useCommonHighchartsOptions } from "../../../../hooks/chart/useCommonHighchartsOptions";

export const useChartOptions = (
  chartData: [number, number][],
  lineColor: string,
  width?: number,
  height?: number
): Highcharts.Options => {
  const commonHighchartsOptions = useCommonHighchartsOptions();
  const theme = useTheme();

  return merge({}, commonHighchartsOptions, {
    chart: {
      type: "area",
      width,
      height,
      backgroundColor: "transparent",
      plotBackgroundColor: "transparent",
    },
    series: [
      {
        data: chartData,
        type: "area",
        color: lineColor,
      },
    ],
    title: {
      text: "",
    },
    tooltip: {
      enabled: false,
    },
    xAxis: {
      enabled: false,
      type: "datetime",
      tickLength: 0,
      lineColor: theme.palette.border.secondary,
      labels: {
        enabled: false,
      },
    },
    yAxis: {
      gridLineWidth: 0,
      title: {
        text: "",
      },
      labels: {
        enabled: false,
      },
    },
    plotOptions: {
      series: {
        enableMouseTracking: false,
      },
      area: {
        fillColor: {
          stops: [
            [
              0,
              Highcharts.color(lineColor).setOpacity(0.1).get("rgba") as string,
            ],
            [
              1,
              Highcharts.color(lineColor).setOpacity(0).get("rgba") as string,
            ],
          ],
        },
      },
    },
    legend: {
      enabled: false,
    },
  } as Highcharts.Options);
};
